import request from '@/util/request';
import qs from 'qs';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/blacklist/page', Object.assign({}, options, { params }));

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/blacklist/submit', params, options, {
    'Content-Type': 'application/json',
  });

// 批量删除
export const delApi = (params, options) =>
  request.post('/api/v4ward/callcenter/blacklist/remove', qs.stringify(params), options);
